(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer_mj"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFooterMj(root) {
      var sections = (root || document).querySelectorAll('.footer-mj');

      sections.forEach(function (section) {
        if (section.dataset.footerMjReady === 'true') return;
        section.dataset.footerMjReady = 'true';

        var toggles = section.querySelectorAll('[data-footer-toggle]');

        toggles.forEach(function (toggle) {
          toggle.addEventListener('click', function () {
            var expanded = toggle.getAttribute('aria-expanded') === 'true';
            var content = toggle.nextElementSibling;

            toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

            if (content) {
              content.hidden = expanded;
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFooterMj(document);
      });
    } else {
      initFooterMj(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initFooterMj(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mj"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeaderMj(root) {
      var sections = (root || document).querySelectorAll('.header-mj');

      sections.forEach(function (section) {
        if (section.dataset.headerMjReady === 'true') return;
        section.dataset.headerMjReady = 'true';

        var drawer = section.querySelector('[data-drawer]');
        var openButton = section.querySelector('[data-drawer-open]');
        var closeButtons = section.querySelectorAll('[data-drawer-close]');
        var toggles = section.querySelectorAll('[data-accordion-toggle]');

        function openDrawer() {
          if (!drawer) return;
          drawer.classList.add('is-open');
          openButton.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
        }

        function closeDrawer() {
          if (!drawer) return;
          drawer.classList.remove('is-open');
          openButton.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
        }

        if (openButton) {
          openButton.addEventListener('click', openDrawer);
        }

        closeButtons.forEach(function (button) {
          button.addEventListener('click', closeDrawer);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            closeDrawer();
          }
        });

        toggles.forEach(function (toggle) {
          toggle.addEventListener('click', function () {
            var expanded = toggle.getAttribute('aria-expanded') === 'true';
            var content = toggle.nextElementSibling;

            toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

            if (content) {
              content.hidden = expanded;
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initHeaderMj(document);
      });
    } else {
      initHeaderMj(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initHeaderMj(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_collection_mj_new"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHomeCollectionMjNew(root) {
      var sections = (root || document).querySelectorAll('.home-collection-mj-new');

      sections.forEach(function (section) {
        if (section.dataset.sliderReady === 'true') return;
        section.dataset.sliderReady = 'true';

        var track = section.querySelector('[data-track]');
        var prev = section.querySelector('.home-collection-mj-new__nav--prev');
        var next = section.querySelector('.home-collection-mj-new__nav--next');

        if (!track || !prev || !next) return;

        function getStep() {
          var card = track.querySelector('.home-collection-mj-new__card');
          if (!card) return 0;

          var cardWidth = card.getBoundingClientRect().width;
          var trackStyles = window.getComputedStyle(track);
          var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
          return cardWidth + gap;
        }

        function updateNav() {
          var maxScroll = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
        });

        next.addEventListener('click', function () {
          track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initHomeCollectionMjNew(document);
      });
    } else {
      initHomeCollectionMjNew(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initHomeCollectionMjNew(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_collection_reels_mj"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReelsCollection(root) {
      var sections = (root || document).querySelectorAll('.home-collection-reels-mj');

      sections.forEach(function (section) {
        if (section.dataset.reelsInit === 'true') return;
        section.dataset.reelsInit = 'true';

        var track = section.querySelector('[data-track]');
        var prev = section.querySelector('.home-collection-reels-mj__nav--prev');
        var next = section.querySelector('.home-collection-reels-mj__nav--next');
        var cards = section.querySelectorAll('.home-collection-reels-mj__card');

        function getStep() {
          var firstCard = track.querySelector('.home-collection-reels-mj__card');
          if (!firstCard) return 0;
          var width = firstCard.getBoundingClientRect().width;
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || 0);
          return width + gap;
        }

        function updateNav() {
          if (!track || !prev || !next) return;
          var maxScroll = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        if (prev && next && track) {
          prev.addEventListener('click', function () {
            track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
          });
          next.addEventListener('click', function () {
            track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
          });
          track.addEventListener('scroll', updateNav, { passive: true });
          window.addEventListener('resize', updateNav);
          updateNav();
        }

        cards.forEach(function (card) {
          var video = card.querySelector('video.home-collection-reels-mj__video, .home-collection-reels-mj__video video');
          var playButton = card.querySelector('[data-play-toggle]');

          if (!video) return;

          video.muted = true;
          video.playsInline = true;

          // Hide play icon when playing, show when paused/ended
          video.addEventListener('play', function () {
            if (playButton) playButton.style.display = 'none';
          });
          video.addEventListener('pause', function () {
            if (playButton) playButton.style.display = '';
          });
          video.addEventListener('ended', function () {
            if (playButton) playButton.style.display = '';
          });

          // Desktop: hover plays, mouse leave pauses
          card.addEventListener('mouseenter', function () {
            if (window.innerWidth > 749) {
              video.play().catch(function () {});
            }
          });
          card.addEventListener('mouseleave', function () {
            if (window.innerWidth > 749) {
              video.pause();
              video.currentTime = 0;
            }
          });

          // Click anywhere on card (mobile) or play button: pause if playing
          card.addEventListener('click', function () {
            if (!video.paused) {
              video.pause();
            }
          });

          // Play button: start playing (for mobile first tap)
          if (playButton) {
            playButton.addEventListener('click', function (event) {
              event.stopPropagation(); // don't let card click fire too
              if (video.paused) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initReelsCollection(document);
      });
    } else {
      initReelsCollection(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initReelsCollection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_collection_slider_mj"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollectionSlider(root) {
      var sections = (root || document).querySelectorAll('.home-collection-slider-mj');

      sections.forEach(function (section) {
        if (section.dataset.sliderInit === 'true') return;
        section.dataset.sliderInit = 'true';

        var track = section.querySelector('[data-track]');
        var prev = section.querySelector('.home-collection-slider-mj__nav--prev');
        var next = section.querySelector('.home-collection-slider-mj__nav--next');

        if (!track || !prev || !next) return;

        function getStep() {
          var firstCard = track.querySelector('.home-collection-slider-mj__card');
          if (!firstCard) return 0;
          var cardWidth = firstCard.getBoundingClientRect().width;
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || 0);
          return cardWidth + gap;
        }

        function updateNav() {
          var maxScroll = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
        });

        next.addEventListener('click', function () {
          track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCollectionSlider(document);
      });
    } else {
      initCollectionSlider(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initCollectionSlider(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_wer_bnr"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHomeWerBnr(root) {
      var sections = (root || document).querySelectorAll('.home-wer-bnr');

      sections.forEach(function (section) {
        if (section.dataset.homeWerInit === 'true') return;
        section.dataset.homeWerInit = 'true';

        var tabs = section.querySelectorAll('.home-wer-bnr__tab');
        var panels = section.querySelectorAll('.home-wer-bnr__panel');

        function setActive(target) {
          tabs.forEach(function (button) {
            var isActive = button.getAttribute('data-target') === target;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var isActive = panel.getAttribute('data-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            setActive(tab.getAttribute('data-target'));
          });
        });

        setActive('men');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initHomeWerBnr(document);
      });
    } else {
      initHomeWerBnr(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initHomeWerBnr(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review_section_mj"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviewSectionMj(root) {
      var sections = (root || document).querySelectorAll('.review-section-mj');

      sections.forEach(function (section) {
        if (section.dataset.reviewSliderReady === 'true') return;
        section.dataset.reviewSliderReady = 'true';

        var track = section.querySelector('[data-track]');
        var prev = section.querySelector('.review-section-mj__nav--prev');
        var next = section.querySelector('.review-section-mj__nav--next');

        if (!track || !prev || !next) return;

        function getStep() {
          var firstCard = track.querySelector('.review-section-mj__card');
          if (!firstCard) return 0;

          var width = firstCard.getBoundingClientRect().width;
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || 0);
          return width + gap;
        }

        function updateNav() {
          var maxScroll = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', function () {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initReviewSectionMj(document);
      });
    } else {
      initReviewSectionMj(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initReviewSectionMj(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_banner"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function() {
            const shopBtn = document.querySelectorAll('.shop-btn, .mobile-shop-btn');
            
            shopBtn.forEach(btn => {
                btn.addEventListener('click', function() {
                    this.style.transform = 'scale(0.95)';
                    setTimeout(() => {
                        this.style.transform = 'scale(1)';
                    }, 150);
                });
            });	

            // Trigger animations on load
            setTimeout(() => {
                document.querySelectorAll('.animate-in').forEach(el => {
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                });
            }, 100);
        });
    
  } catch(e) { console.error(e); }
})();
})();
